import Link from "next/link";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav className="component-padding py-4 font-body" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-2 text-sm">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            {index > 0 && <span className="opacity-40">/</span>}
            {item.href ? (
              <Link href={item.href} className="opacity-60 hover:opacity-100">
                {item.label}
              </Link>
            ) : (
              <span className="opacity-80">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
